<template>
  <b-modal
    id="view_error"
    size="xl"
    no-close-on-backdrop
    scrollable
    title="ERRO"
    @show="evOnShow"
    @shown="evOnShown"
    @hide="evOnHide"
  >
    <b-row>
      <b-col>
        <template v-if="document">
          <object-viewer :data="document" />
        </template>
      </b-col>
    </b-row>
    <template #modal-footer>
      <b-row no-gutters align-h="end">
        <b-col cols="auto">
          <v-btn color="v-danger" class="ml-2" @click="remove">
            <i class="fa fa-trash mr-2"></i> APAGAR
          </v-btn>
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>

<script>
import toast from "../../components/ToastNotification";
import api from "../../services/api";
import ObjectViewer from "./object-viewer.vue";

export default {
  name: "ViewError",

  components: { ObjectViewer },

  props: {
    item: { required: true },
  },

  data() {
    return {
      errors: [],
      loading: false,

      document: null,
    };
  },

  watch: {
    item() {
      if (this.item) this.$bvModal.show("view_error");
    },
  },

  methods: {
    async evOnShow() {
      this.retrieve().then();
    },

    async evOnShown() {},

    async evOnHide() {
      this.$emit("close");
    },

    async retrieve() {
      try {
        this.loading = true;

        const params = { id: this.item._id };
        const response = await api.get("/admin/error", { params });
        const { error, errors, item } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.document = item;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    async remove() {
      try {
        this.loading = true;

        const params = { id: this.item._id };
        const response = await api.delete("/admin/error", { params });
        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message);
          this.$bvModal.hide("view_error");
          this.$emit("updated");
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style>
</style>